import React, { useState } from 'react';
import { ChevronLeft } from 'lucide-react';
import { AuthHeader } from './components/AuthHeader/AuthHeader';
import { SocialLoginButtons } from './components/SocialLoginButtons/SocialLoginButtons';
import { LoginForm } from './components/LoginForm/LoginForm';
import { SignupForm } from './components/SignupForm/SignupForm';
import './LoginCard.css';

export function LoginCard({
  onLogin,
  onSignup,
  onOAuthLogin,
  isLoading,
  error,
  clearError,
}) {
  const [viewMode, setViewMode] = useState('social');
  const [emailTab, setEmailTab] = useState('login');

  const handleEmailClick = () => {
    setViewMode('email');
    clearError?.();
  };

  const handleBackToSocial = () => {
    setViewMode('social');
    clearError?.();
  };

  return (
    <div className="login-card">
      <AuthHeader activeTab={viewMode === 'social' ? 'login' : emailTab} />

      {viewMode === 'social' ? (
        <SocialLoginButtons
          onOAuthLogin={onOAuthLogin}
          onEmailClick={handleEmailClick}
          isLoading={isLoading}
        />
      ) : (
        <div className="login-card__email-view">
          <button
            type="button"
            className="login-card__back-to-social"
            onClick={handleBackToSocial}
          >
            <ChevronLeft size={16} />
            <span>다른 로그인 방법</span>
          </button>

          <div className="login-card__tabs">
            <button
              type="button"
              className={`login-card__tab ${emailTab === 'login' ? 'login-card__tab--active' : ''}`}
              onClick={() => setEmailTab('login')}
            >
              이메일 로그인
            </button>
            <button
              type="button"
              className={`login-card__tab ${emailTab === 'signup' ? 'login-card__tab--active' : ''}`}
              onClick={() => setEmailTab('signup')}
            >
              이메일 회원가입
            </button>
          </div>

          <div className="login-card__body">
            {emailTab === 'login' ? (
              <LoginForm onSubmit={onLogin} isLoading={isLoading} error={error} />
            ) : (
              <SignupForm onSubmit={onSignup} isLoading={isLoading} error={error} />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
